import { render, staticRenderFns } from "./FixDeskSearchResultBeautify.vue?vue&type=template&id=546ea423&scoped=true"
import script from "./FixDeskSearchResultBeautify.vue?vue&type=script&lang=js"
export * from "./FixDeskSearchResultBeautify.vue?vue&type=script&lang=js"
import style0 from "./FixDeskSearchResultBeautify.vue?vue&type=style&index=0&id=546ea423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ea423",
  null
  
)

export default component.exports